import axios from 'axios'
import { server } from '../constants'
import authService from '../Services/auth'
import { checkApiUnauthorized } from '../helpers/checkApiUnauthorized'

const httpClient = axios.create({
  baseURL: server.BASE_URL
})

httpClient.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${authService.accessToken()}`

    return config
  },
  function (error) {
    // Do something with request error

    // checkApiUnauthorized(error)

    return Promise.reject(error)
  }
)

export default httpClient
